import { type OneDriveFilesResponse } from '../..';
import useGraphClient from '../../../../utils/microsoft/useGraphClient';
import oneDriveFilesCache from '../../oneDriveFilesCache';
import { type OneDriveFile, type OneDriveFolder } from '../../types';

const useLoadFolderItems = () => {
  const graphClient = useGraphClient();

  const loadFolderItems = async (
    folder: OneDriveFolder,
  ): Promise<(OneDriveFile | OneDriveFolder)[]> => {
    if (oneDriveFilesCache.has(folder.id)) {
      return oneDriveFilesCache.get(folder.id)!;
    }

    const loadedFolderItems: OneDriveFilesResponse = await graphClient
      .api(`/me/drive/items/${folder.id}/children`)
      .get();

    oneDriveFilesCache.set(folder.id, loadedFolderItems.value);

    return loadedFolderItems.value;
  };

  return loadFolderItems;
};

export default useLoadFolderItems;
